import { QueryClient, type InvalidateQueryFilters } from '@tanstack/react-query';

/** One cache for the whole SPA; shared by the tRPC options proxy and the React provider. */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

/**
 * Invalidate several query families and resolve once their active queries have refetched. A
 * mutation's `onSuccess` that RETURNS this keeps `isPending` (and so a button's busy state) true
 * until the page already shows the result — no flash of an idle button before the data changes.
 */
export function invalidateAll(...filters: InvalidateQueryFilters[]): Promise<void> {
  return Promise.all(filters.map((f) => queryClient.invalidateQueries(f))).then(() => undefined);
}
